import VueRouter from 'vue-router'
const Home = ()=> import('@/pages/Home')
const About = ()=> import('@/pages/About')
const News = ()=> import('@/pages/News')
const NewsDet = ()=> import('@/pages/News/detail.vue')
const Download = ()=>  import('@/pages/Download')
const Innovation = ()=> import('@/pages/Innovation')
const Product = () => import('@/pages/Product')
const Module = () => import('@/pages/Product/module.vue')
const Dealer = () => import('@/pages/Product/dealer.vue')
const Solution = () => import('@/pages/Solution')
const Case = () => import('@/pages/Case')
const Sustain = () => import('@/pages/Sustain')

export default new VueRouter({
    mode:'history',
    routes:[
        {
            path: '/it',
            component: Home
        },
        {
            path: '/it/about',
            component: About
        },
        {
            name:'news',
            path:'/it/news/:p?',
            component: News,
            props({query}){
                return { p:query.p }
            }
        },
        {
            path: '/it/newsdet',
            component: NewsDet,
            props({query}){
                return { id:query.id }
            }
        },
        {
            name:'load',
            path: '/it/download',
            component: Download,
            props({query}){
                return { pid:query.pid, cid:query.cid, p:query.p }
            }
        },
        {
            path: '/it/innovation',
            component: Innovation
        },
        {
            path: '/it/product',
            component: Product,
            props({query}){
                return { id:query.id }
            }
        },
        {
            path:'/it/module',
            component: Module,
        },
        {
            path:'/it/dealer',
            component: Dealer,
        },
        {
            path: '/it/solution',
            component: Solution,
            props({query}){
                return{ id:query.id }
            }
        },
        {
            name: 'case',
            path:'/it/case',
            component:Case,
            props({query}){
                return { p:query.p }
            }
        },
        {
            path:'/it/sustainability',
            component: Sustain
        }
    ]
})
